var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(-852 -11821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17470",
    "data-name": "Path 17470",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(852 11821)",
    fill: "#143398"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook-app-symbol",
    transform: "translate(829.71 11831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M43.956,19.775v-9.02h3.026l.454-3.516h-3.48V4.995c0-1.018.281-1.711,1.742-1.711h1.86V.138A25.225,25.225,0,0,0,44.847,0c-2.684,0-4.522,1.638-4.522,4.646V7.239H37.29v3.516h3.035v9.02Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.1481019a220e1661f8ed3aeb570669ca.svg";
export { ForwardRef as ReactComponent };